import React from "react";
import { Icon } from "./registry";
/* ============================================================
   Fence Works — Visualizer
   The customer's photo with the real 3D fence standing in it — to
   scale, lit to match — or a 3D backyard when there's no photo yet.
   Every style the Product Editor offers, swapped instantly, all in
   the browser: no AI render, no wait, no per-image cost.
   The studio itself lives in viz3d/Studio.tsx.

   BUNDLE RULE: the studio pulls three.js in statically, so it is
   ONLY ever imported via React.lazy — the WebGL engine stays in its
   own chunk and never lands in the main bundle.
   ============================================================ */
const StudioLazy: any = React.lazy(() => import("./viz3d/Studio"));

function Visualizer(props: any) {
  return (
    <React.Suspense fallback={
      <div className="page fade-up">
        <div className="muted" style={{ textAlign: "center", padding: "140px 0", fontSize: 13 }}>
          <Icon name="layers" size={22} style={{ display: "block", margin: "0 auto 10px", color: "var(--teal)" }} />Loading the 3D visualizer…
        </div>
      </div>
    }>
      <StudioLazy {...props} />
    </React.Suspense>
  );
}

Object.assign(window, { Visualizer });

export { Visualizer };
